import React from "react";
import { useLocation } from "react-router-dom";

const PdfViewer = () => {
  const location = useLocation();

  const pdfMap = {
    "/privacy-policy": "/pdf/privacy-policy.pdf",
    "/tnc": "/pdf/terms-and-conditions.pdf",
  };

  const pdfUrl = pdfMap[location.pathname];

  if (!pdfUrl) return null;

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src={pdfUrl}
        title="PDF Viewer"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
};

export default PdfViewer;
